/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import DataTable from "../../customers/DataTable";
import { connect } from "react-redux";
import gql from "graphql-tag";
import { spinnerService } from "@chevtek/react-spinners";
import { mainDashboardQuery } from "../../data/customQueries.js";
import moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "../../components/CustomButtons/Button.jsx";
import { toast } from "react-toastify";
import * as actionTypes from "../../redux/actions";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import { Row, Col } from "reactstrap";
import imgPlaceholder from "../../assets/img/logo-placeholder.jpg";
import { Storage } from "aws-amplify";
let vehicleDispData = [];
const heads = [
  {
    id: "id",
    label: "Vehicle ID"
  },
  { id: "make", label: "Make" },
  { id: "model", label: "Model" },
  { id: "vin", label: "VIN" },
  {
    id: "inspections",
    label: "Inspection Due By:"
  },
  { id: "defects", label: "Defects" }
];
const VendorWork = ({ client, ...props }) => {
  const [selectedCustomer, setSelectedCustomer] = useState({
    id: "",
    name: ""
  });
  const [selectedCompany, setSelectedCompany] = useState("");
  const [vehiclesList, setVehiclesList] = useState([]);
  const [displayVehicles, setDisplayVehicles] = useState(false);
  const [inspectVehicle, setInspectVehicle] = useState("");
  const [inspectDialog, setInspectDialog] = useState(false);
  const [logo, setLogo] = useState(imgPlaceholder);
  const loadData = async id => {
    let customer = id;
    if (
      !["", null, undefined].includes(customer) &&
      customer !== selectedCustomer
    ) {
      setDisplayVehicles(false);
      vehicleDispData = [];
      spinnerService.show("mySpinner");
      try {
        let res = null;
        let dueDate = moment(new Date()).add(15, "days");
        res = (await client.query({
          query: gql(mainDashboardQuery),
          fetchPolicy: `network-only`,
          variables: { id: customer, dueDate: dueDate }
        })).data.getCustomer;
        let pic = res.picture;
        if (pic !== null) {
          if (pic !== undefined) {
            Storage.get(pic.key)
              .then(pictureObj => {
                setLogo(pictureObj);
              })
              .catch(() => {});
          }
        }
        setSelectedCustomer({
          id,
          name: res.customerFirstName + " " + res.customerLastName
        });
        setSelectedCompany(res.companyName);
        if (res.vehicles.items !== null) {
          let index = 0;
          await res.vehicles.items.forEach(item => {
            index++;
            let vehDefectCount = 0;
            let dispObj = {
              key: index,
              redTag: false,
              customerVehicleId: item.customerVehicleId,
              VIN: item.VIN,
              id: item.id,
              sort: 0,
              vehCategory: item.vehicleType.vehicleCategory,
              mainPic: item.mainPic,
              make: item.make,
              model: item.model,
              deactivateBIT: item.deactivateBIT,
              deactivateDOT: item.deactivateDOT,
              regType: res.registeredInspectionType,
              customer: res.id,
              redTagCounter: 0,
              status: item.vehicleStatus
            };

            if (
              !(
                item.nextInspectionDue === undefined ||
                item.nextInspectionDue === null
              )
            ) {
              if (item.nextInspectionDue.length > 0) {
                dispObj.nextInspectionDue = item.nextInspectionDue;
              }
            }

            if (res.registeredInspectionType !== "FEDERAL_BIT") {
              if (
                !(
                  item.nextInspectionDue === undefined ||
                  item.nextInspectionDue === null
                )
              ) {
                if (item.nextInspectionDue.length > 0) {
                  dispObj.nextDue = ["", null, undefined].includes(
                    item.nextInspectionDue[0].nextDueDate
                  )
                    ? null
                    : item.nextInspectionDue[0].nextDueDate;
                }
              }
            } else if (res.registeredInspectionType === "FEDERAL_BIT") {
              const date1 =
                item.nextInspectionDue && item.nextInspectionDue.length > 0
                  ? item.nextInspectionDue[0].nextDueDate
                  : null;
              const date2 =
                item.nextInspectionDue && item.nextInspectionDue.length > 1
                  ? item.nextInspectionDue[1].nextDueDate
                  : null;

              if (
                ["", null, undefined].includes(date1) &&
                ["", null, undefined].includes(date2)
              ) {
                dispObj.nextDue = null;
              } else if (
                ["", null, undefined].includes(date1) &&
                !["", null, undefined].includes(date2)
              ) {
                dispObj.nextDue = date2;
              } else if (
                !["", null, undefined].includes(date1) &&
                ["", null, undefined].includes(date2)
              ) {
                dispObj.nextDue = date1;
              } else if (
                !["", null, undefined].includes(date1) &&
                !["", null, undefined].includes(date2)
              ) {
                if (moment(new Date(date2)).isBefore(new Date(date1))) {
                  dispObj.nextDue = date2;
                } else {
                  dispObj.nextDue = date1;
                }
              }
            }
            res.defectsByStatus.items.map(defect => {
              if (
                defect.vehicle !== null &&
                !["REPAIRED", "REVOKED"].includes(defect.status)
              ) {
                if (defect.vehicle.id === item.id) {
                  if (defect.redTag === true) {
                    dispObj.redTagCounter++;
                    dispObj.redTag = true;
                  }
                  vehDefectCount++;
                  dispObj.defectStatus = defect.status;
                }
              }
            });
            dispObj.defectCount = vehDefectCount;
            vehicleDispData.push(dispObj);
          });
        }
        // let sortCounter = 0;
        let tempArr = vehicleDispData.filter(a => a.defectCount > 0);
        tempArr.sort((a, b) => {
          if (a.defectCount < b.defectCount) {
            // sortCounter++;
            // a.sort = sortCounter;
            return 1;
          }
          // b.sort = sortCounter;
          return -1;
        });
        let tempArr1 = tempArr.filter(a => a.redTag);
        tempArr1.sort((a, b) => {
          if (a.redTagCounter < b.redTagCounter) {
            // sortCounter++;
            // a.sort = sortCounter;
            return 1;
          }
          // b.sort = sortCounter;
          return -1;
        });
        let tempArr3 = [...tempArr1, ...tempArr, ...vehicleDispData];
        tempArr3 = new Set(tempArr3);
        tempArr3 = [...tempArr3];
        vehicleDispData = tempArr3;
        setVehiclesList(vehicleDispData);
        setDisplayVehicles(true);
      } catch (error) {
        toast.error("Something Went Wrong");
      }
      spinnerService.hide("mySpinner");
    }
  };

  useEffect(() => {
    loadData(props.match.params.cId);
    props.customerForMechanic(props.match.params.cId);
  }, []);

  const handleInspectVehicle = v => {
    if (v.regType === "FEDERAL" && v.deactivateDOT) {
      toast.error("DOT disbaled for this Vehicle");
    } else if (v.regType === "BIT" && v.deactivateBIT) {
      toast.error("BIT disbaled for this Vehicle");
    } else if (
      v.regType === "FEDERAL_BIT" &&
      v.deactivateDOT &&
      v.deactivateBIT
    ) {
      toast.error("DOT & BIT disbaled for this Vehicle");
    } else {
      setInspectVehicle(v.id);
      setInspectDialog(true);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={inspectDialog}
        onClose={() => setInspectDialog(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Select Inspection</DialogTitle>
        <DialogActions>
          <Button
            color="info"
            onClick={() =>
              props.history.push(
                `/vendor/customer/${props.match.params.cId}/inspection/new/start/inspection/${inspectVehicle}/otf`,
                {
                  mech: true,
                  selectedCustomer: selectedCustomer.id
                }
              )
            }
          >
            On The FLY
          </Button>
          <Button
            color="info"
            onClick={() =>
              props.history.push(
                `/vendor/customer/${props.match.params.cId}/inspection/new/details/${inspectVehicle}`,
                {
                  mech: true,
                  selectedCustomer: selectedCustomer.id
                }
              )
            }
          >
            DOT/BIT
          </Button>
        </DialogActions>
      </Dialog>
      <Row>
        <Col xs={12} sm={6} lg={6}>
          <div style={{ float: "left" }}>
            <Avatar style={{ height: 80, width: 80 }}>
              <img src={logo} style={{ height: 80, width: 80 }} alt="..." />
            </Avatar>
          </div>
          <div style={{ float: "left", paddingLeft: 10, marginTop: 10 }}>
            <div style={{ fontSize: "24px" }}>{selectedCompany}</div>
            <div style={{ marginTop: "10px" }}>
              Customer: {selectedCustomer.name}
            </div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={6}>
          <div style={{ float: "right", paddingTop: "25px" }}>
            <span
              style={{
                cursor: "pointer",
                color: "purple",
                fontSize: "18px"
              }}
              onClick={() => {
                props.history.push(`/mech`, {
                  change: true
                });
              }}
            >
              {"(Change Customer)"}
            </span>
          </div>
        </Col>
      </Row>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          {/* <Router> */}
          <div style={{ float: "left", padding: "10px" }}></div>
          <Card>
            <CardHeader>
              {!["", null, undefined].includes(selectedCustomer.id) ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <h4>
                    {["", null, undefined].includes(selectedCompany) ? (
                      "Company"
                    ) : (
                      <div>Registered Vehicles for {selectedCompany}</div>
                    )}
                  </h4>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                  }}
                >
                  <h5>Select Company To View Vehicles</h5>
                </div>
              )}
            </CardHeader>
            <CardBody style={{ minHeight: 585 }}>
              <React.Fragment>
                {displayVehicles && (
                  <DataTable
                    // rows={vehicleDispData}
                    rows={vehiclesList}
                    heads={heads}
                    table="vendor"
                    client={client}
                    handleInspectVehicle={veh => handleInspectVehicle(veh)}
                  />
                )}
              </React.Fragment>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </React.Fragment>
  );
};
VendorWork.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
  customerForMechanic: PropTypes.func,
  client: PropTypes.object,
  user: PropTypes.object
};

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    custformech: state.config.custformech
  };
};
const mapDispatchToProps = dispatch => {
  return {
    customerForMechanic: data => dispatch(actionTypes.customerForMechanic(data))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorWork);



// WEBPACK FOOTER //
// ./src/views/Dashboard/VendorWork.js